<form class="d-flex flex-column justify-content-between w-100" [formGroup]="form" (ngSubmit)="saveFormData()">
    <div class="form-content">
        <ng-container *ngFor="let field of fieldArray;">
            <ng-container *ngIf="!hiddenControl(field)" [ngSwitch]="field.type">

                <ng-container *ngSwitchCase="'input'">
                    <div class="form-group">
                        <label>{{field.label}} <span
                                *ngIf="form.get(field.controlName).enabled && field.validators?.required"
                                class="text-danger">*</span></label>
                        <input type="text" class="form-control" [formControlName]="field.controlName"
                            [placeholder]="field.placeholder || ''" (change)="changeFunction(field)"
                            autocomplete="new-password" />
                        <ng-container *ngIf="getErrorMsg(field)">
                            <small class="form-text text-danger">{{getErrorMsg(field)}}</small>
                        </ng-container>
                    </div>
                </ng-container>

                <ng-container *ngSwitchCase="'password'">
                    <div class="form-group">
                        <label>{{field.label}} <span
                                *ngIf="form.get(field.controlName).enabled && field.validators?.required"
                                class="text-danger">*</span></label>

                        <div class="input-group">
                            <input type="password" class="form-control" #passwordField
                                [formControlName]="field.controlName" [placeholder]="field.placeholder || ''"
                                (change)="changeFunction(field)" (keyup)="setPasswordValidator(field)"
                                autocomplete="new-password" />
                            <div class="input-group-append" *ngIf="!field.readonly">
                                <button type="button" class="btn btn-sm btn-light border px-2 py-1"
                                    (click)="passwordField.type === 'password' ? passwordField.type = 'text' : passwordField.type = 'password'">
                                    <img src="assets/icons/eye.svg" style="width: 20px;"
                                        [class.d-none]="passwordField.type === 'text'" />
                                    <img src="assets/icons/eye-slash.svg" style="width: 20px;"
                                        [class.d-none]="passwordField.type === 'password'" />
                                </button>
                            </div>
                        </div>
                        <ng-container *ngIf="getErrorMsg(field)">
                            <small class="form-text text-danger">{{getErrorMsg(field)}}</small>
                        </ng-container>
                    </div>
                </ng-container>

                <ng-container *ngSwitchCase="'textarea'">
                    <div class="form-group">
                        <label>{{field.label}} <span
                                *ngIf="form.get(field.controlName).enabled && field.validators?.required"
                                class="text-danger">*</span></label>
                        <textarea class="form-control" [formControlName]="field.controlName"
                            [placeholder]="field.placeholder || ''" (change)="changeFunction(field)"
                            autocomplete="new-password"></textarea>
                        <ng-container *ngIf="getErrorMsg(field)">
                            <small class="form-text text-danger">{{getErrorMsg(field)}}</small>
                        </ng-container>
                    </div>
                </ng-container>

                <ng-container *ngSwitchCase="'dropdown'">
                    <div class="form-group">
                        <label>{{field.label}} <span
                                *ngIf="form.get(field.controlName).enabled && field.validators?.required"
                                class="text-danger">*</span></label>

                        <ng-container *ngIf="!field.ddlOptions">
                            <small class="form-text text-danger">Options are not passed</small>
                        </ng-container>
                        <ng-container *ngIf="field.ddlOptions">
                            <ng-container [ngSwitch]="field.ddlOptions.layout">
                                <ng-container *ngSwitchCase="'ng-select'">
                                    <ng-select [formControlName]="field.controlName"
                                        [placeholder]="field.placeholder || ''"
                                        [multiple]="field.ddlOptions.multiOption" (change)="changeFunction(field)"
                                        autocomplete="new-password" [searchable]="field.ddlOptions.searchable"
                                        appendTo="body">
                                        <ng-container [ngSwitch]="field.ddlOptions.type">
                                            <ng-container *ngSwitchCase="'object'">
                                                <ng-option
                                                    *ngFor="let option of (field.ddlOptions.options || field.ddlOptions.options$?.getValue())"
                                                    [value]="option[field.ddlOptions.value]">
                                                    {{option[field.ddlOptions.label]}}
                                                </ng-option>
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                <ng-option
                                                    *ngFor="let option of (field.ddlOptions.options || field.ddlOptions.options$?.getValue())"
                                                    [value]="option">
                                                    {{option}}
                                                </ng-option>
                                            </ng-container>
                                        </ng-container>
                                    </ng-select>
                                </ng-container>
                                <ng-container *ngSwitchCase="'ng-multiselect-dropdown'">
                                    <ng-multiselect-dropdown [formControlName]="field.controlName"
                                        [placeholder]="field.placeholder || ''"
                                        (onSelect)="fnChangeQuest(quest, subQuest)" [settings]="{
                                            singleSelection:!field.ddlOptions.multiOption,
                                            itemsShowLimit:field.ddlOptions.itemsShowLimit || 3,
                                            allowSearchFilter:field.ddlOptions.searchable,
                                            idField:field.ddlOptions.value,
                                            textField:field.ddlOptions.label,
                                            maxHeight:field.ddlOptions.maxHeight || 150
                                        }"
                                        [data]="(field.ddlOptions.options || field.ddlOptions.options$?.getValue())">
                                    </ng-multiselect-dropdown>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <select class="form-control" [formControlName]="field.controlName"
                                        [placeholder]="field.placeholder || ''"
                                        [attr.multiple]="field.ddlOptions.multiOption" (change)="changeFunction(field)"
                                        autocomplete="new-password">
                                        <option [disabled]="field.ddlOptions.multiOption" [value]="null"
                                            *ngIf="field.placeholder">
                                            {{field.placeholder}}</option>
                                        <ng-container [ngSwitch]="field.ddlOptions.type">
                                            <ng-container *ngSwitchCase="'object'">
                                                <option
                                                    *ngFor="let option of (field.ddlOptions.options || field.ddlOptions.options$?.getValue())"
                                                    [value]="option[field.ddlOptions.value]">
                                                    {{option[field.ddlOptions.label]}}
                                                </option>
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                <option
                                                    *ngFor="let option of (field.ddlOptions.options || field.ddlOptions.options$?.getValue())"
                                                    [value]="option">
                                                    {{option}}
                                                </option>
                                            </ng-container>
                                        </ng-container>
                                    </select>

                                </ng-container>
                            </ng-container>

                        </ng-container>
                        <ng-container *ngIf="getErrorMsg(field)">
                            <small class="form-text text-danger">{{getErrorMsg(field)}}</small>
                        </ng-container>
                    </div>
                </ng-container>

                <ng-container *ngSwitchCase="'date'">
                    <div class="form-group">
                        <label>{{field.label}} <span
                                *ngIf="form.get(field.controlName).enabled && field.validators?.required"
                                class="text-danger">*</span></label>

                        <div class="input-group">
                            <input type="text" class="form-control" [formControlName]="field.controlName"
                                [attr.placeholder]="DateFormat" ngbDatepicker #datePicker="ngbDatepicker"
                                [attr.dateFormat]="DateFormat" [minDate]="field.minDate?.date"
                                [maxDate]="field.maxDate?.date" (change)="changeFunction(field)"
                                (dateSelect)="changeFunction(field)" autocomplete="new-password" />

                            <div class="input-group-append" *ngIf="!field.readonly">
                                <button class="btn btn-outline-secondary datepicker-icon" (click)="datePicker.toggle()"
                                    type="button"></button>
                            </div>
                        </div>

                        <ng-container *ngIf="getErrorMsg(field)">
                            <small class="form-text text-danger">{{getErrorMsg(field)}}</small>
                        </ng-container>
                    </div>
                </ng-container>

                <ng-container *ngSwitchCase="'checkbox'">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" [formControlName]="field.controlName"
                                (change)="changeFunction(field)">
                            <label class="form-check-label">
                                {{field.label}}
                            </label>
                            <ng-container *ngIf="getErrorMsg(field)">
                                <small class="form-text text-danger">{{getErrorMsg(field)}}</small>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngSwitchCase="'staticText'">
                    <div class="form-group">
                        <label>{{field.label}}</label>
                        <p>
                            <ng-container *ngIf="field.placeholder">
                                <span [innerHTML]="field.placeholder"></span>
                            </ng-container>
                            <ng-container *ngIf="!field.placeholder">
                                <span [innerHTML]="form.getRawValue()[field.controlName]"></span>
                            </ng-container>
                        </p>
                    </div>
                </ng-container>

                <ng-container *ngSwitchCase="'separator'">
                    <hr />
                </ng-container>

                <ng-container *ngSwitchCase="'info'">
                    <div class="form-group">
                        <div class="d-flex align-items-center">
                            <div [innerHTML]="field.info.text" [ngClass]="field.info.class"
                                [ngStyle]="field.info.style"></div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngSwitchCase="'jsonEditor'">
                    <div class="form-group">
                        <label>{{field.label}} <span
                                *ngIf="form.get(field.controlName).enabled && field.validators?.required"
                                class="text-danger">*</span></label>

                        <json-editor [formControlName]="field.controlName" class="form-json-editor" [options]="{
                            modes:field.jsonEditor?.modes || ['code', 'text', 'tree', 'view'],
                            mode:field.jsonEditor?.mode || 'code'
                        }" (change)="changeFunction(field)"></json-editor>

                        <ng-container *ngIf="getErrorMsg(field)">
                            <small class="form-text text-danger">{{getErrorMsg(field)}}</small>
                        </ng-container>
                    </div>
                </ng-container>

                <ng-container *ngSwitchCase="'button'">
                    <div class="form-group">
                        <div class="d-flex align-items-center gap-2">
                            <ng-container *ngFor="let button of field.buttons;">
                                <button type="button" [ngClass]="button.class" (click)="buttonClicked(button)">
                                    <span>{{button.name}}</span>
                                </button>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngSwitchCase="'template'">
                    <ng-container *ngTemplateOutlet="field.templateRef"></ng-container>
                </ng-container>

            </ng-container>
        </ng-container>
    </div>
    <div class="form-footer">
        <div class="d-flex flex-wrap align-items-center justify-content-center gap-2">
            <button type="submit" *ngIf="submitButton.length" class="btn btn-primary px-6">{{submitButton}}</button>
            <ng-container *ngFor="let button of footerButtons;">
                <button type="button" [ngClass]="button.class" (click)="buttonClicked(button)">
                    <span>{{button.name}}</span>
                </button>
            </ng-container>
            <button type="button" *ngIf="cancelButton.length" class="btn btn-light px-6"
                (click)="fnCancelBtn()">{{cancelButton}}</button>
        </div>
    </div>
</form>
